import { apiClient, setAccessToken, unwrap } from './apiClient';

export const authApi = {
  async login(credentials) {
    const response = await apiClient.post('/auth/login', credentials);
    const data = unwrap(response);
    setAccessToken(data.accessToken);
    return data;
  },
  async requestOtp(payload) {
    const body = typeof payload === 'string' ? { email: payload, identity: payload } : payload;
    const response = await apiClient.post('/auth/otp/request', body);
    return unwrap(response);
  },
  async verifyOtp(payload) {
    const response = await apiClient.post('/auth/otp/verify', payload);
    const data = unwrap(response);
    setAccessToken(data.accessToken);
    return data;
  },
  async logout() {
    try {
      await apiClient.post('/auth/logout');
    } finally {
      setAccessToken(null);
    }
  },
  async refresh() {
    const response = await apiClient.post('/auth/refresh');
    const data = unwrap(response);
    setAccessToken(data.accessToken);
    return data;
  },
  async me() {
    const response = await apiClient.get('/auth/me');
    return unwrap(response);
  },
  forgotPassword(email) {
    return apiClient.post('/auth/forgot-password', { email });
  },
  resetPassword(payload) {
    return apiClient.post('/auth/reset-password', payload);
  },
  verifyMfa(code) {
    return apiClient.post('/auth/mfa/verify', { code });
  },
  regenerateRecoveryCodes() {
    return apiClient.post('/auth/recovery-codes/regenerate');
  }
};
